import { defineStore } from 'pinia'
import {
    getDatabase, ref, update, get, child,
    // query, where
    // onValue

} from "firebase/database";
// import "firebase/database"
import { useToast } from "vue-toastification";
import { authStore } from './auth'
// import { friendStore } from './friends';

import { addDoc, collection, getFirestore, deleteDoc, doc, getDocs } from 'firebase/firestore'

const toast = useToast()
// useStore could be anything like useUser, useCart
// the first argument is a unique id of the store across your application
export const firedataStore = defineStore('firedataStore', {
    state: () => ({
        allSessions: [],
        appVersion: "1.2",
        userSettings: { distances: [4, 6, 8, 10] },
        updating: false,
        friends: [],
        loadingData: null
    }),
    getters: {
        totalRequests(state) {
            let i = 0;
            if (!state.friends.length) return 0;
            state.friends.forEach(friend => {
                // console.log(friend);
                if (friend.status === "request") i++;
                // if (friend.status === "pending") i++;
            });
            return i;
        },
        totalPending(state) {
            let i = 0;
            if (!state.friends.length) return 0;
            state.friends.forEach(friend => {
                if (friend.status === "pending") i++;
            });
            return i;
        },
    },
    actions: {
        async getAllSessions() {
            this.loadingData = "loading sessions..."
            const fdb = getFirestore();
            const useAuthStore = authStore()
            const allSessions = [];


            await getDocs(collection(fdb, "data/" + useAuthStore.user.uid + "/sessions")).then((data) => {
                data.forEach(session => {
                    // console.log(session.id, " => ", session.data());
                    const sess = session.data();
                    sess.id = session.id;
                    allSessions.push(sess)
                });
                this.loadingData = null;
            });

            // const q = query(collection(fdb, "cities"), where("capital", "==", true));

            // const querySnapshot = await getDocs(q);
            // querySnapshot.forEach((doc) => {
            //     // doc.data() is never undefined for query doc snapshots
            //     console.log(doc.id, " => ", doc.data());
            // });


            this.allSessions = allSessions;



            // this.loadFriends();
        },

        async deleteSession(payload) {
            var index = this.allSessions.map(session => {
                return session.id;
            }).indexOf(payload.id);

            this.allSessions.splice(index, 1);
            const fdb = getFirestore();
            const useAuthStore = authStore()
            console.log(payload.id);
            await deleteDoc(doc(fdb, "data/" + useAuthStore.user.uid + "/sessions", payload.id))




        },
        async getData() {
            const useAuthStore = authStore()
            if (useAuthStore) return; // PER NÅ KJØRER IKKE DENNE SÅLENGE DENNE ER AKTIV
            console.log("GET DATA RUNNING");

            if (localStorage.getItem('friends')) {
                if (localStorage.getItem('friends') !== "undefined") {
                    this.friends = JSON.parse(localStorage.getItem('friends'));
                    // toast("Sessions loaded.")
                }
            }
            if (localStorage.getItem('userSettings')) {
                if (localStorage.getItem('userSettings') !== "undefined" && JSON.parse(localStorage.getItem('userSettings')) instanceof Object) {
                    this.userSettings = JSON.parse(localStorage.getItem('userSettings'));
                }
            }
            if (localStorage.getItem('allSessions')) {
                if (localStorage.getItem('allSessions') !== "undefined") {
                    this.allSessions = JSON.parse(localStorage.getItem('allSessions'));
                    // toast("Sessions loaded from localstorage.")
                }
            }



            const dbRef = ref(getDatabase());
            // const userRef = ref(db, "/users/" + useAuthStore.user.uid);


            get(child(dbRef, `users/${useAuthStore.user.uid}`)).then((snapshot) => {
                if (snapshot.exists()) {
                    // console.log(snapshot.val());
                }
                if (snapshot.val() && snapshot.val().allSessions) {
                    if (localStorage.getItem('allSessions')) {
                        // Sjekk om lokal data eller databasedata er nyest.
                        if (snapshot.val() && snapshot.val().lastEdited > localStorage.getItem('lastEdited')) {
                            // Dersom data fra database er nyere enn lokal lagret data, erstatt allSessions.
                            localStorage.setItem('allSessions', JSON.stringify(snapshot.val().allSessions));
                            this.allSessions = snapshot.val().allSessions;
                            // toast("Sessions loaded from online data.")
                        }
                    } else {
                        this.allSessions = snapshot.val().allSessions;
                        localStorage.setItem('allSessions', JSON.stringify(snapshot.val().allSessions));
                    }
                    if (snapshot.val() && snapshot.val().userSettings) {
                        localStorage.setItem('userSettings', JSON.stringify(snapshot.val().userSettings));
                    } else {
                        const db = getDatabase();
                        const updates = {};
                        updates["/users/" + useAuthStore.user.uid + "/userSettings"] = this.userSettings;
                        update(ref(db), updates)
                            .then(() => {
                                localStorage.setItem('userSettings', JSON.stringify(this.userSettings));
                                toast("User settings updated.")
                            })
                            .catch((error) => {
                                toast("User data save error." + error)
                            });
                    }
                }
                // this.loadFriends();
            });
        },
        async loadFriends() {
            this.loadingData = "loading friends..."
            const fdb = getFirestore();
            const useAuthStore = authStore()
            const friends = [];
            await getDocs(collection(fdb, "users/" + useAuthStore.user.uid + "/friends")).then((data) => {
                data.forEach(friend => {
                    // console.log(session.id, " => ", session.data());
                    const fre = friend.data();
                    console.log(fre);
                    fre.id = friend.id;
                    friends.push(fre)
                });
                this.loadingData = null;
            });
            this.friends = friends;



            // const db = getDatabase();
            // const useAuthStore = authStore()
            // const reff = ref(db, "/users/" + useAuthStore.user.uid + "/friends");
            // console.log("load friends");
            // console.log(useAuthStore.user.uid);
            // onValue(reff, (snapshot) => {
            //     console.log(snapshot.exists());
            //     console.log(snapshot.val());
            //     if (snapshot.val()) {
            //         this.friends = [];
            //         let friends = [];
            //         snapshot.forEach(friend => {
            //             friends.push(friend.val());
            //         });
            //         this.friends = friends;
            //         const useFriendsStore = friendStore();
            //         useFriendsStore.getAllFriendsSessions();
            //         localStorage.setItem('friends', JSON.stringify(this.friends));
            //     }
            // });

        },
        async addSession(payload) {
            const useAuthStore = authStore()
            const fdb = getFirestore();
            try {
                const docRef = await addDoc(collection(fdb, "data/" + useAuthStore.user.uid + "/sessions"),
                    payload.session
                )
                console.log("Document written with ID: ", docRef.id);
                this.getAllSessions();
            } catch (e) {
                console.error("Error adding document: ", e);
            }
        },
        save() {
            const useAuthStore = authStore()
            // console.log(useAuthStore.user.uid) 
            // if (useAuthStore.user.uid) return;
            this.updating = true; // Bruker denne til å ikke laste dager f.eks. når den holder på å oppdatere!
            const lastEdited = new Date().getTime();
            localStorage.setItem('allSessions', JSON.stringify(this.allSessions));
            localStorage.setItem('userSettings', JSON.stringify(this.userSettings));
            localStorage.setItem('lastEdited', lastEdited);
            const db = getDatabase();
            const updates = {};
            updates["/users/" + useAuthStore.user.uid + "/email"] = useAuthStore.user.email;
            updates["/users/" + useAuthStore.user.uid + "/allSessions"] = this.allSessions;
            updates["/users/" + useAuthStore.user.uid + "/userSettings"] = this.userSettings;
            updates["/users/" + useAuthStore.user.uid + "/lastEdited"] = lastEdited;
            update(ref(db), updates)
                .then(() => {

                    toast("Data synced online.")
                    // if (Array.isArray(this.allSessions)) if (this.allSessions.length === 1) location.reload();
                    this.updating = false;
                })
                .catch((error) => {
                    toast("User data save error: " + error)
                });
        },
        async resetAll() {

            const useAuthStore = authStore();
            const fdb = getFirestore();
            const userId = useAuthStore.user.uid;

            const sessionsRef = collection(fdb, "data", userId, "sessions");
            const sessionsSnapshot = await getDocs(sessionsRef);

            try {
                sessionsSnapshot.forEach((doc) => {
                    deleteDoc(doc.ref);
                });
                localStorage.removeItem('allSessions');
                toast("User data reset success online.")

            }
            catch (e) {
                toast("User data reset error." + e)

            }

        },
    }
})
